import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import React from "react";

import NavigationBar from "./NavigationBar";

const MobileNavigationBar = props => {
  const { setOpen, open } = props;
  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        data-testid="mobile-navigation-menu-button"
        onClick={() => setOpen(!open)}
      >
        <MenuIcon />
      </IconButton>
      <NavigationBar {...props} />
    </>
  );
};

export default MobileNavigationBar;
